/**
 * @since 7.1.0
 */
export interface ListEventsInRangeOptions {
  /**
   * The timestamp in milliseconds.
   *
   * @since 7.1.0
   */
  from: number;
  /**
   * The timestamp in milliseconds.
   *
   * @since 7.1.0
   */
  to: number;
}
